const initState = {
    token: null,
    user: {
        id: null,
        idAcount: null,
        name: "",
        lastName: "",
        email: "",
        date: "",
        numberId: null,
        userName: "",
        password: "",
        idState: null
    },

    /**control */
    connection: false,
    error: false,
    message: "",
    recoverPassword: {
        result: false,
        connection: false,
        error: false,
        message: '',
    },
    changePassword: {
        result: false,
        connection: false,
        error: false,
        message: '',
    },

};

export default initState;